'use client';

import { Button, Modal } from '@common/components';
import { useState } from 'react';

interface ExpiredModalProps {
  open: boolean;
}

export const ExpiredModal = ({ open }: ExpiredModalProps) => {
  const [isDismissed, setIsDismissed] = useState(false);

  return (
    <Modal
      opened={open && !isDismissed}
      onClose={() => setIsDismissed(true)}
      header={<span className="w-full text-center">이벤트가 종료되었어요</span>}
      description={
        <span className="block text-center">
          많은 관심과 참여 감사드립니다.
          <br />더 큰 혜택으로 찾아올게요!
        </span>
      }
      buttonFooter={
        <Button dimensions="H48" onClick={() => setIsDismissed(true)}>
          확인
        </Button>
      }
    />
  );
};
